<template>
  <div>
    <layout-one>
      <el-form
        :model="form"
        label-width="160px"
        :inline="true"
        ref="form"
        :rules="rules"
      >
        <!-- 1. 基本信息部分 -->
        <div class="section">

          <div class="sectionBox">
              <el-form-item label="考试类型">
                <el-radio-group v-model="form.examTypeId">
                  <el-radio-button :disabled="true" :label="item.id" class="examType" v-for="item in examTypeList" :key="item.id">{{item.name}}</el-radio-button>
                </el-radio-group>
              </el-form-item>
          </div>  

          <h4>基本信息</h4>
          <!-- (1) 基本信息 -->
          <div class="sectionBox">
            <el-form-item label="考试批次">
              <span>{{ planCode }}</span>
            </el-form-item>
          </div>
          <!-- (2) 考试批次 -->
          <div class="sectionBox">
            <el-form-item label="考试批次名称" prop="name">
              <el-input
                placeholder="请输入"
                v-model="form.name"
                :disabled="true"
                class="inputwidth"
              ></el-input>
            </el-form-item>
          </div>
          <!-- (3) 报名人工审核 -->
          <div class="sectionBox">
            <el-form-item label="报名人工审核" :required="true">
              <!-- 报名人工审核 button -->
              <el-radio-group v-model="form.form_needAudit" :disabled="true">
                <el-radio-button label="1" class="examType"
                  >一级人工审核</el-radio-button
                >
                <el-radio-button label="2" class="examType"
                  >二级人工审核</el-radio-button
                >
                <el-radio-button label="0" class="examType"
                  >不做人工审核</el-radio-button
                >
              </el-radio-group>
            </el-form-item>
          </div>
          <!-- 新增考点场次 -->
          <div class="sectionBox">
            <el-form-item label="允许选考试场次">
              <el-switch
                v-model="form.optionalSession"
                :active-value="1"
                :inactive-value="0"
                disabled
              ></el-switch>
            </el-form-item>
          </div>
          <!-- (4) 是否下载准考证 -->
          <div class="sectionBox">
            <el-form-item label="下载准考证">
              <el-switch
                v-model="form.downloadEntrance"
                :active-value="1"
                :inactive-value="0"
                :disabled="true"
              ></el-switch>
            </el-form-item>
          </div>
          <!-- 是否开启缴费 -->
          <div class="sectionBox">
            <el-form-item label="是否开启缴费">
              <el-switch
                v-model="form.isPay"
                :active-value="1"
                :inactive-value="0"
                :disabled="true"
              ></el-switch>
            </el-form-item>
          </div>
          <div class="sectionBox">
            <el-form-item label="允许学生查看考试时间">
              <el-switch
                v-model="form.allowViewExamTimeFlag"
                :active-value="0"
                :inactive-value="1"
                :disabled="true"
              ></el-switch>
            </el-form-item>
          </div>
          <div class="sectionBox">
            <el-form-item label="允许学生查看考试成绩">
              <el-switch
                v-model="form.allowViewExamScoreFlag"
                :active-value="0"
                :inactive-value="1"
                :disabled="true"
              ></el-switch>
            </el-form-item>
          </div>
          <div class="sectionBox" v-if="form.allowViewExamScoreFlag == 0">
            <el-form-item label="允许学生成绩复核">
              <el-switch
                v-model="form.scoreReview"
                :active-value="1"
                :inactive-value="0"
                :disabled="true"
              ></el-switch>
            </el-form-item>
          </div>

          <div class="sectionBox" v-if="form.scoreReview == 1">
            <el-form-item label="允许学生查看分项成绩">
              <el-switch
                v-model="form.scoreReviewShowSubCourseScore"
                :active-value="1"
                :inactive-value="0"
                :disabled="true"
              ></el-switch>
              <p style="display: inline-block; height: 40px; line-height: 40px;">（开启后，学生成绩复核通过后可查看该门课程各分项成绩）</p>
            </el-form-item>
          </div>


        </div>

        <!-- 2. 考试批次时间设置 -->
        <div class="section mt20">
          <h4>时间设置</h4>
          <!-- (1) 报名起止时间 -->
          <div class="sectionBox">
            <el-form-item label="报名起止时间">
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.beginSign"
                :disabled="true"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
              至
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.endSign"
                :disabled="true"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- (2) 初审截止时间 -->
          <div class="sectionBox" v-if="hiddenPrimaryEndAudit">
            <el-form-item label="初审截止时间" prop="primaryEndAudit">
              <el-date-picker
                :disabled="true"
                :value-format="dataFormat"
                v-model="form.primaryEndAudit"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- (3) 终审截止时间 -->
          <div class="sectionBox" v-if="hiddenEndAudit">
            <el-form-item :label="endAuditLabel">
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.endAudit"
                :disabled="true"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- (4) 缴费起止时间 -->
          <div class="sectionBox" v-if="form.isPay == 1">
            <el-form-item label="缴费起止时间">
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.startPay"
                :disabled="true"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
              至
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.endPay"
                :disabled="true"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- (5) 准考证打印时间 -->
          <div class="sectionBox">
            <el-form-item
              label="准考证打印时间"
              v-if="form.downloadEntrance"
            >
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.beginEntrance"
                :disabled="true"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- (6) 考试起止时间 -->
          <div class="sectionBox">
            <el-form-item>
              <span slot="label">{{form.examBeginAndEndCustomName}}起止时间</span>
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.beginExam"
                :disabled="true"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
              至
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.endExam"
                :disabled="true"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- (7) 成绩查询开始时间 -->
          <div class="sectionBox">
            <el-form-item label="成绩查询开始时间">
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.beginScoreCheck"
                :disabled="true"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="sectionBox" v-if="form.scoreReview === 1">
            <el-form-item label="成绩复核申请起止时间" prop="scoreReviewBeginTime">
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.scoreReviewBeginTime"
                :disabled="true"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item> 至 </el-form-item>
            <el-form-item label="" prop="scoreReviewEndTime">
              <el-date-picker
                :value-format="dataFormat"
                v-model="form.scoreReviewEndTime"
                :disabled="true"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="sectionBox" v-if="form.scoreReview === 1">
            <el-form-item label="成绩复核审核截止时间" prop="scoreReviewAuditEndTime">
              <el-date-picker
                :disabled="true"
                :value-format="dataFormat"
                v-model="form.scoreReviewAuditEndTime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </div>

        <!-- 3. 课程设置 -->
        <div class="section mt20">
          <h4>课程设置</h4>
          <div class="sectionBox">
            <el-form-item label="考试科目选择">
              <div class="stationBox">
                <el-checkbox-group
                  v-model="form.form_courseIdList"
                  @change="handleCheckedChange"
                >
                  <el-checkbox
                    disabled
                    v-for="course in courseData"
                    :label="course.id"
                    :key="course.id"
                    >{{ course.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div>
                <el-checkbox
                  v-if="signCoureCountall && form.form_courseIdList.length >= 2"
                  class="limitationcheckbox"
                  v-model="form.signCoureCount"
                  :true-label="1"
                  :false-label="0"
                  disabled
                  >单科目报名限制
                  <span>(此选项是控制学生在报名环节只能选择一个科目)</span>
                </el-checkbox>
              </div>
              <div v-if="form.optionalSession === 0">
                <el-checkbox
                  disabled
                  label="允许学生选考试日期"
                  v-if="form.form_courseIdList.length === 1"
                  v-model="form.optionalExamDate"
                  :true-label="1"
                  :false-label="0"
                >
                  允许学生选考试日期<span v-if="false">
                    限制每天<el-input
                      disabled
                      v-model="form.everyBodyLimit"
                      class="inputsize"
                    />人考试
                  </span>
                </el-checkbox>
                <el-checkbox
                  disabled
                  label="允许学生选考试日期"
                  v-else-if="
                    form.form_courseIdList.length >= 2 &&
                    form.signCoureCount == 1
                  "
                  v-model="form.optionalExamDate"
                  :true-label="1"
                  :false-label="0"
                >
                  允许学生选考试日期<span v-if="false">
                    限制每天<el-input
                      disabled
                      v-model="form.everyBodyLimit"
                      class="inputsize"
                    />人考试
                  </span>
                </el-checkbox>
              </div>
              <!-- 新增 从这开始 -->
              <div v-if="showSelectDateNumDiv" class="selectDateNumDiv">
                <!-- 下部表格区域 -->
                <div class="table-container">
                  <el-table
                    :data="tableSelectedData"
                    :show-header="false"
                    style="width: 100%"
                  >
                    <el-table-column prop="col1" width="400">
                      <template slot-scope="{ $index }">
                        <div class="cell-content" style="padding-left:20px;">
                          <el-checkbox v-model="checkedDates[$index * 2]" class="limitationcheckboxsSpecial" disabled>
                            <span class="date-text">{{ baseDatesSource[$index * 2] }} 限制每天</span>
                            <el-input
                              v-model="limitValues[$index * 2]"
                              class="inputsize"
                              disabled
                            ></el-input>
                            <span>人</span>
                          </el-checkbox>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column prop="col2" width="400">
                      <template slot-scope="{ $index }">
                        <div class="cell-content" v-if="$index * 2 + 1 < baseDatesSource.length">
                          <el-checkbox v-model="checkedDates[$index * 2 + 1]" class="limitationcheckboxsSpecial" disabled>
                          <span class="date-text">{{ baseDatesSource[$index * 2 + 1] }} 限制每天</span>
                          <el-input
                            v-model="limitValues[$index * 2 + 1]"
                            class="inputsize"
                            disabled
                          ></el-input>
                          <span>人</span>
                          </el-checkbox>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>

              </div>
            </el-form-item>
          </div>

          <div class="secion mt20" v-if="ExemptCourseList.length > 1">
            <h4>免考课程范围设置</h4>
            <el-form-item label="   ">
              <div class="stationBox">

                  <el-radio-group v-model="courseIdsExempt" style="width: 100%; margin-top: 16px;">
                    <el-radio disabled :label="item.courseId" v-for="item in ExemptCourseList" :key="item.courseId" style="width: 360px; height: 40px;">{{item.courseName}}</el-radio>
                  </el-radio-group>

              </div>
            </el-form-item>
          </div>


        </div>

        <!-- ------- 费用设置 ------- -->
        <div class="section mt20" v-if="form.isPay == 1">
          <h4>费用设置</h4>
          <!-- (1) 缴费渠道 -->
          <div class="sectionBox">
            <el-form-item label="缴费渠道" :required="true">
              <el-radio-group v-model="form.payType" :disabled="true">
                <el-radio-button label="1" class="examType"
                  >平台在线缴费</el-radio-button
                >
                <el-radio-button label="2" class="examType"
                  >第三方自主缴费</el-radio-button
                >
              </el-radio-group>
            </el-form-item>
          </div>
          <!-- (2) 选择的课程费用 -->
          <div
            class="sectionBox"
            v-show="form.payType && PayMentInfo.needPayCourse.length > 0"
          >
            <el-form-item label="课程费用">
              <div class="stationBox">
                <div
                  v-for="course in PayMentInfo.needPayCourse"
                  :key="course.id"
                  style="margin-bottom: 8px"
                >
                  <el-form-item :label="course.name">
                    <el-input
                      placeholder="请输入"
                      v-model.number="PayMentInfo.PayCourse[course.id]"
                      disabled
                    >
                      <template slot="suffix">元&nbsp;&nbsp;</template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
          </div>

          <!-- (3) 第三方自主缴费 - 二维码 -->
          <div class="sectionBox" v-if="form.payType == 2">
            <el-form-item label="第三方自主缴费二维码">
              <el-upload
                action=""
                :disabled="true"
                class="avatar-uploader dinb"
                :show-file-list="false"
              >
                <img
                  style="width: 100%; height: 100%;"
                  v-if="payInfo.imageUrl"
                  :src="payInfo.imageUrl"
                  class="avatar"
                />
                <i class="el-icon-plus avatar-uploader-icon" v-else></i>
              </el-upload>
            </el-form-item>
          </div>
          <!-- (4) 缴费说明 -->
          <div class="sectionBox" v-if="form.payType == 2">
            <el-form-item label="缴费说明">
              <el-input
                class="textarea"
                type="textarea"
                :disabled="true"
                v-model="payInfo.paymentText"
                placeholder="请添加缴费说明，以小写分号;分隔多条说明，可预览查看"
              ></el-input>
              <div class="col_blue cp pr preBtn">
                <span>预览</span>
                <div class="codePreview col_black">
                  <div class="picArea">
                    <img
                      v-if="payInfo.imageUrl"
                      :src="payInfo.imageUrl"
                      alt=""
                    />
                  </div>
                  <div class="payContent">
                    <p v-for="(item, index) in payRemarkList" :key="index">
                      {{ `${index + 1}.${item}` }}
                    </p>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>

        <!-- 5. 报名须知 -->
        <div class="section mt20">
          <h4>报名须知</h4>
          <div class="sectionBox">
            <el-form-item label="报名须知">
              <div class="editor" v-html="form.signRemark"></div>
            </el-form-item>
          </div>
          <div class="sectionBox">
            <el-form-item label="报名须知阅读倒计时">
              <div>{{ form.signRemarkTime }} 秒</div>
            </el-form-item>
          </div>
        </div>
        <!-- 合格证 -->
        <div class="section mt20">
          <h4>合格证设置</h4>
          <div class="sectionBox">
            <el-form-item label="合格证">
              <el-button
                round
                plain
                @click="certificateShow"
                v-if="isUploadcertificate"
                >预览合格证</el-button
              >
              <template v-else> 未上传合格证模板 </template>
            </el-form-item>
          </div>
        </div>
        <!-- 6. 准考证 -->
        <div class="section mt20" v-if="form.downloadEntrance">
          <h4>准考证设置</h4>
          <div class="sectionBox">
            <el-form-item label="准考证">
              <el-button round plain @click="leftShow" v-if="isUploadTicket"
                >预览准考证</el-button
              >
              <template v-else> 未上传准考证模板 </template>
            </el-form-item>
          </div>
        </div>
        <!-- 申述表-->
        <div class="section mt20" v-if="form.scoreReview === 1">
          <h4>上传复核表</h4>
          <div class="sectionBox">
            <el-form-item label="复核表">
              <el-button
                round
                plain
                @click="scoreReviewshow"
                v-if="isReviewFilepath"
                >预览复核表</el-button
              >
              <template v-else> 未上传复核表模板 </template>
            </el-form-item>
          </div>
        </div>
        <div class="section mt20">
          <h4>选择短信签名</h4>
          <div class="sectionBox">
            <el-form-item label="短信签名" prop="smsTitleId">
              <!-- <el-input placeholder="请输入" v-model="form.name" :disabled="isPublish"></el-input> -->
              <el-select
                v-model="form.smsTitleId"
                placeholder="请选择"
                disabled
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-one>
  </div>
</template>
<script>
const EditorConfig = {
  // 编辑器不自动被内容撑高
  autoHeightEnabled: false,
  // 初始容器高度
  initialFrameHeight: 200,
  // 初始容器宽度
  initialFrameWidth: "90%",
  // 元素路径
  elementPathEnabled: false,
  // 启用自动保存
  enableAutoSave: false,
  // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！部署在国外的服务器，如果无法访问，请自备梯子）
  // serverUrl: 'http://35.201.165.105:8000/controller.php',
  // serverUrl: '/api/resources/ots/student/ueditorjsp/jsp/controller.jsp?name=cate',
  // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
  UEDITOR_HOME_URL: "/UEditor/",
  // 编辑器图标设置
  // toolbars: [
  //     [
  //         "source",
  //         "|",
  //         "bold",
  //         "italic",
  //         "underline",
  //         "|",
  //         'simpleupload',
  //         'insertimage',
  //         "|"
  //     ]
  // ],

  toolbars: [
    [
      "undo",
      "redo",
      "|",
      "bold",
      "italic",
      "underline",
      "fontborder",
      "strikethrough",
      "superscript",
      "subscript",
      "|",
      "forecolor",
      "backcolor",
      "insertorderedlist",
      "insertunorderedlist",
      "|",
      "justifyleft",
      "justifycenter",
      "justifyright",
      "justifyjustify",
      // 'removeformat', 'formatmatch','blockquote', ,  '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter'
    ],
  ],
};
import { mapMutations } from "vuex";
import { getPlanCourseExemptAPI, getPlanCourseExemptScopeAPI } from "@/http/modules/baseSet/course";

import { getSelectCourse } from "@/http/modules/baseSet/course";
import {
  getPlanCodeFn,
  getSinglePlan,
  getTenantSmsTitle,
  examTypeListApi
} from "@/http/modules/examSet/examBatch";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  name: "checkBatch",
  components: { VueUeditorWrap },
  data() {
    return {
              // 免考课程
      ExemptCourseList: [],
      // 免考课程Id
      courseIdsExempt: "",
      // 免考失败提示
      messageDialog: false,
      signCoureCountall: false,
      options: [],
      PayMentInfo: {
        needPayCourse: [],
        PayCourse: {},
      },
      hiddenPrimaryEndAudit: false,
      scoreReviewEndTime: "",
      endAuditLabel: "审核截止时间",
      hiddenEndAudit: true,
      isUploadTicket: false,
      isUploadcertificate: false,
      isReviewFilepath: false,
      entranceFilepath: "",
      certificateFilepath: "",
      scoreReviewFilepath: "",
      isEdit: false,
      saveMethods: "addOrEdit",
      backMethods: "goIndex",
      planCode: "",
      dataFormat: "yyyy-MM-dd HH:mm:ss",
      courseScopeText: "",
      aaa: "",
      form: {
        examTypeId: "",
        optionalExamDate: "",
        everyBodyLimit: "",
        scoreReviewBeginTime: "",
        scoreReviewEndTime: "",
        scoreReviewAuditEndTime: "",
        scoreReview: "",
        smsTitleId: "",
        name: "",
        form_needAudit: "1",
        form_needIpCheck: false,
        money: "",
        beginSign: "",
        endSign: "",
        endAudit: "",
        startPay: "",
        endPay: "",
        isPay: "",
        payType: "",
        beginEntrance: "",
        beginExam: "",
        endExam: "",
        beginScoreCheck: "",
        signRemark: "",
        signRemarkTime: "",
        examRemark: "",
        form_courseIdList: [],
        primaryEndAudit: "",
        downloadEntrance: "",
        optionalSession: "",
        signCoureCount: "",
        // 允许学生查看考试时间
        allowViewExamTimeFlag: "",
        // 允许学生查看考试成绩
        allowViewExamScoreFlag: "",
        // 考试起止时间标题
        examBeginAndEndCustomName: "",
        scoreReviewShowSubCourseScore: "",
        //允许考生自行选择的多个考试日期
        planExamdayList: [],
      },
      examTypeList: [],
      rules: {
        name: [
          { required: true, message: "请填写考试批次名称", trigger: "blur" },
          { min: 1, max: 50, message: "最多可输入50个字", trigger: "blur" },
        ],
        money: [
          { type: "number", message: "收费必须为数字值", trigger: "blur" },
        ],
      },
      courseData: [],
      editorConfig: {},
      payInfo: {
        imageUrl: "",
        onlinePayment: "",
        paymentText: "",
      },
      // 批量控制每天多少人--开始↓↓↓↓↓↓↓↓
      // 是否显示选择日期的弹窗
      showSelectDateNumDiv: false,
      // 需要循环的日期数组
      baseDatesSource: [],
      // 当前日期对应复选框集合的选中状态
      checkedDates: [],
      // 当前日期对应的人数集合
      limitValues: [],
      // 用于表格渲染的虚拟数据
      tableSelectedData: []
      //批量控制每天多少人--结束↑↑↑↑↑↑↑↑
    };
  },
  computed: {
    payRemarkList() {
      return this.payInfo.paymentText
        ? this.payInfo.paymentText.split(";")
        : null;
    },
  },
  created() {
    this.initStatus();
    this.editorConfig = EditorConfig;
    this.initCourseData();
  },
  mounted() {
    this.getExamTypeList();
    this.initData();
  },
  methods: {
    ...mapMutations(["SAVE_PAGE_THIS"]),

    // 山财，获取免考课程
    async initData() {
      let planId = this.$route.query.id;
      const { data } = await getPlanCourseExemptAPI({planId})
      this.ExemptCourseList = data;

      const res = await getPlanCourseExemptScopeAPI({planId});
      if (res.data.length > 0) {
        this.courseIdsExempt = res.data[0].id;
      }
    },

    getExamTypeList(){
      examTypeListApi().then(res=>{
        if (res.code == 1) {
          this.examTypeList = res.data;
        }
      })
    },

    /*******************************************
     * @examTypeChange 报名人工审核方式按钮改变事件
     *******************************************/
    examTypeChange(val) {
      if (val == 1) {
        this.hiddenPrimaryEndAudit = false;
        this.hiddenEndAudit = true;
        this.endAuditLabel = "审核截止时间";
      } else if (val == 2) {
        this.hiddenPrimaryEndAudit = true;
        this.hiddenEndAudit = true;
        this.endAuditLabel = "终审截止时间";
      } else if (val == 0) {
        this.hiddenPrimaryEndAudit = false;
        this.hiddenEndAudit = false;
        this.endAuditLabel = "";
      }
    },

    /*******************************************
     * @initStatus 配置展示数据
     *******************************************/
    async initStatus() {
      if (this.$route.query.id) {
        this.isEdit = true;
        let id = this.$route.query.id;
        const { data } = await getSinglePlan({ planId: id });
        for (let item in this.form) {
          this.form[item] = data[item] != null ? data[item] : this.form[item];
        }
        if (!data.courseList) data.courseList = [];
        this.form.planId = data.id;
        this.form.scoreReview = data.scoreReview;
        this.form.form_needAudit = data.needAudit;
        this.form.form_needIpCheck = data.needIpCheck == 1 ? true : false;
        this.form.form_courseIdList = data.courseList.map((item) => item.id);
        this.isUploadTicket = JSON.parse(data.isExistEntranceTemp);
        this.isUploadcertificate = data.certificateFilepath ? true : false;
        this.payInfo.imageUrl = data.payPic;
        this.payInfo.paymentText = data.payText;
        this.payInfo.onlinePayment = data.payType;
        this.entranceFilepath = data.entranceFilepath;
        this.certificateFilepath = data.certificateFilepath;
        this.PayMentInfo.needPayCourse = data.courseList;
        this.PayMentInfo.optionalExamDate = data.optionalExamDate;
        this.PayMentInfo.everyBodyLimit = data.everyBodyLimit;
        this.isReviewFilepath = data.scoreReviewFilepath ? true : false;

        this.scoreReviewFilepath = data.scoreReviewFilepath;
        data.courseList.map((e) => {
          this.PayMentInfo.PayCourse[e.id] = e.money;
        });
        this.planCode = data.planCode;
        this.examTypeChange(data.needAudit);
        if (this.form.form_courseIdList.length >= 2) {
          this.signCoureCountall = true;
        } else {
          this.signCoureCountall = false;
        }

        // 2025年06月19日
        this.form.planExamdayList = JSON.parse(data.planExamdayList);
        this.createTableData();
      }
    },

    /*******************************************
     * @initPlanCode 批次名
     *******************************************/
    async initPlanCode() {
      const { data } = await getPlanCodeFn();
      this.planCode = data;
    },

    /*******************************************
     * @initCourseData 课程列表
     *******************************************/
    async initCourseData() {
      const { data } = await getSelectCourse();
      this.courseData = data;

      getTenantSmsTitle().then((res) => {
        this.options = res.data;
      });
    },

    /*******************************************
     * @handleCheckedChange 课程#缴费配置
     *******************************************/
    handleCheckedChange(value) {
      this.PayMentInfo.needPayCourse = [];
      this.courseData.map((e) => {
        if (value.includes(e.id)) {
          this.PayMentInfo.needPayCourse.push(e);
        }
      });
    },
    leftShow() {
      if (this.entranceFilepath) {
        window.open(this.entranceFilepath);
      } else {
        this.$message.error("准考证模板待上传");
      }
    },
    certificateShow() {
      if (this.certificateFilepath) {
        window.open(this.certificateFilepath);
      } else {
        this.$message.error("合格证模板待上传");
      }
    },
    scoreReviewshow() {
      if (this.scoreReviewFilepath) {
        window.open(this.scoreReviewFilepath);
      } else {
        this.$message.error("申述表模板待上传");
      }
    },
    createTableData(value){
      if(this.form.optionalExamDate === 1){
        this.showSelectDateNumDiv = true;
      }else{
        this.showSelectDateNumDiv = false;
      }
      if(value == 0){return;}

      const beginDate = new Date(this.form.beginExam);
      const endDate = new Date(this.form.endExam);

      const dates = [];
      const currentDate = new Date(beginDate);
      while (currentDate <= endDate) {
        dates.push(this.formatDate(new Date(currentDate)));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      this.baseDatesSource = dates;

      this.checkedDates = new Array(this.baseDatesSource.length).fill(false);
      this.limitValues = new Array(this.baseDatesSource.length).fill(0);
      const rowCount = Math.ceil(this.baseDatesSource.length / 2);

      if (!this.form.planExamdayList || !Array.isArray(this.form.planExamdayList)) {
        this.form.planExamdayList = [];
      }
      //前端接口返回的是：planExamdayList: "[{"examDay":"2025-06-20 00:00:00","limitCount":20},{"examDay":"2025-06-21 00:00:00","limitCount":21},{"examDay":"2025-06-22 00:00:00","limitCount":22}]"
      //根据返回，把checkedDates和limitValues赋值
      this.baseDatesSource.forEach((date, index) => {
        const examDay = this.form.planExamdayList.find(item => item.examDay === this.formatDateForBackend(date));
        if (examDay) {
          this.checkedDates[index] = true;
          this.limitValues[index] = examDay.limitCount;
        }
      });
      this.tableSelectedData = new Array(rowCount).fill({});
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}年${month}月${day}日`;
    },
    formatDateForBackend(dateStr) {
      const [year, month, day] = dateStr.match(/\d+/g);
      return `${year}-${month}-${day} 00:00:00`;
    }
  },
};
</script>

<style lang="less" scoped>
.textarea {
  width: 500px;
  height: 80px;
  /deep/ .el-textarea__inner {
    height: 100%;
  }
}
.preBtn:hover .codePreview {
  display: flex;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 131px;
  height: 131px;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #006aff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 131px;
  height: 131px;
  line-height: 131px;
  text-align: center;
  position: absolute;
  top: 0%;
  left: 0%;
}
.avatar-uploader /deep/ .el-upload:hover .avatar-uploader-icon {
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 3;
}
.section {
  border-bottom: 1px solid #f1f2f5;
  h4 {
    margin-bottom: 30px;
  }
  .sectionBox {
    .lang {
      width: 512px;
    }
    .examType {
      width: 120px;
      margin-right: 16px;
      /deep/ .el-radio-button__inner {
        width: 100%;
      }
    }
  }
  .stationBox {
    width: 1000px;
    max-height: 300px;
    background-color: #f8f9fc;
    overflow-y: auto;
    padding: 20px;
    border-radius: 8px;
    .stationTop {
      display: flex;
      margin-bottom: 20px;
    }
    .searchCourse {
      position: relative;
      .searchPos {
        width: 40px;
        height: 18px;
        line-height: 18px;
        border-left: 1px solid #e1e6ed;
        position: absolute;
        right: 0;
        top: 11px;
        color: #c2c6cc;
        font-size: 14px;
        i {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
  .editor {
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    border-radius: 3px;
    padding: 8px;
    width: 800px;
    height: 200px;
    overflow: auto;
  }
  /deep/ .el-form-item {
    margin-bottom: 30px !important;
  }
  /deep/ .el-radio-button__inner {
    margin-right: 16px;
    color: #45494d !important;
    background: #f4f5f8 !important;
    font-size: 13px;
    border-radius: 4px !important;
    border: 1px solid #dadde6 !important;
    width: 64px;
    height: 32px;
    line-height: 32px;
    padding: 0;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #ebf5ff !important;
    border: 1px solid #006aff !important;
    color: #006aff !important;
    box-shadow: none;
  }
}
.codePreview {
  bottom: -60px;
  left: 40px;
  width: 405px;
  min-height: 487px;
  background: #ffffff;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.12);
  border: 1px solid #dadde6;
  border-radius: 4px;
  //   position: absolute;
  display: none;
  //   display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 32px;
  box-sizing: border-box;
  z-index: 2;
  .picArea {
    width: 280px;
    height: 280px;
    padding: 10px;
    box-sizing: border-box;
    margin: 20px auto;
    img {
      width: 100%;
      height: 100%;
    }
    p {
      text-align: center;
    }
  }
  .payContent {
    width: 100%;
    word-break: break-word;
  }
}
.inputwidth /deep/.el-input__inner {
  width: 500px !important;
}
.inputsize {
  width: 100px;
  margin-left:5px ;
  /deep/.el-input__inner {
    width: 90px;
    height: 26px;
  }
}


.selectDateNumDiv{
  padding:10px;
  background-color: #f5f5f5;
}

.limitationcheckboxsSpecial{
  width: 600px !important;
  color: #606266;
  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #606266;
  }
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.control-panel {
  padding: 15px;
  background: #f5f7fa;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.table-container {
  flex: 1;
  overflow: auto;
}

.cell-content {
  display: flex;
}

.date-text {
  margin: 0 15px;
  min-width: 100px;
}
</style>